import React from 'react';
import { ServiceContextProvider } from '../components/TimeAndExpenseServiceContext';
import InvoiceMaintenancePageComponent from './InvoiceMaintenancePageComponent';
const InvoiceMaintenancePage = () => {
  return (
    <ServiceContextProvider>
      <InvoiceMaintenancePageComponent />
    </ServiceContextProvider>
  );
};
export default InvoiceMaintenancePage;



// WEBPACK FOOTER //
// ./src/components/project-billing/pages/InvoiceMaintenancePage.tsx